import { toast } from "@/hooks/use-toast";
import type { ToastActionElement } from "@/components/ui/toast";
import {
  resolveFriendlyError,
  type ApiErrorLike,
  type ErrorSeverity,
  type FriendlyError,
} from "./errorCatalog";
import { audienceOf, getCurrentUser, type CurrentUserSnapshot } from "@/lib/auth/currentUser";

type ToastVariant = "default" | "destructive" | "success" | "warning" | "info";

function variantForSeverity(severity: ErrorSeverity | undefined): ToastVariant {
  switch (severity) {
    case "warning":
      return "warning";
    case "info":
      return "info";
    default:
      return "destructive";
  }
}

export interface ShowApiErrorOptions {
  fallback?: Partial<FriendlyError>;
  user?: CurrentUserSnapshot | null;
  action?: ToastActionElement;
  duration?: number;
  context?: Record<string, any>;
  report?: boolean;
}

export function showApiError(
  input: ApiErrorLike | Error | string | null | undefined,
  options: ShowApiErrorOptions = {},
): FriendlyError & { raw: string | null } {
  const { fallback, action, duration } = options;
  const user = options.user !== undefined ? options.user : getCurrentUser();
  const friendly = resolveFriendlyError(input, fallback, audienceOf(user));

  toast({
    title: friendly.title,
    description: friendly.description,
    variant: variantForSeverity(friendly.severity),
    ...(action ? { action } : {}),
    ...(duration ? { duration } : {}),
  });

  return friendly;
}
